module.exports = __webpack_public_path__ + "img/antes_despues_270.db634f85.png";